import { render, staticRenderFns } from "./TeamView.vue?vue&type=template&id=41e1e10b&scoped=true&"
import script from "./TeamView.vue?vue&type=script&lang=js&"
export * from "./TeamView.vue?vue&type=script&lang=js&"
import style0 from "./TeamView.vue?vue&type=style&index=0&id=41e1e10b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e1e10b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
